import { Delete } from "lucide-react";

export default function Numpad({ value, onChange, maxLength = 11 }) {
  const handleNumber = (num) => {
    if (value.length < maxLength) {
      onChange(value + num);
    }
  };

  const handleDelete = () => {
    onChange(value.slice(0, -1));
  };

  const handleClear = () => {
    onChange("");
  };

  const buttons = [
    "1", "2", "3",
    "4", "5", "6",
    "7", "8", "9",
    "C", "0", "⌫"
  ];

  return (
    <div className="grid grid-cols-3 gap-4 max-w-sm mx-auto">
      {buttons.map((btn, index) => (
        <button
          key={index}
          data-testid={`numpad-${btn === "⌫" ? "delete" : btn === "C" ? "clear" : btn}`}
          onClick={() => {
            if (btn === "⌫") handleDelete();
            else if (btn === "C") handleClear();
            else handleNumber(btn);
          }}
          className={`numpad-button ${
            btn === "C" ? "bg-red-100 hover:bg-red-200 text-red-600" : ""
          } ${btn === "⌫" ? "bg-amber-100 hover:bg-amber-200 text-amber-600" : ""}`}
        >
          {btn === "⌫" ? <Delete className="w-8 h-8" /> : btn}
        </button>
      ))}
    </div>
  );
}
